import { useState } from "react";
import Icon from "./Icon";
import { changePassword } from "../api/authService";
import { useAuth } from "../contexts/AuthContext";
import { showApiError, showToast } from "../utils/toast";

// Shared current/new/confirm password form. Used both by the forced
// change-password screen (temp passwords) and the self-service Account page.
// On success it refreshes the stored user (clearing must_change_password) and
// calls onDone(freshUser).
export default function ChangePasswordForm({ onDone, submitLabel = "Change password" }) {
  const { updateUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const submit = async (e) => {
    e?.preventDefault();
    setErrors({});
    if (next.length < 8) {
      setErrors({ new_password: "New password must be at least 8 characters" });
      return;
    }
    if (next !== confirm) {
      setErrors({ new_password_confirmation: "Passwords do not match" });
      return;
    }
    setLoading(true);
    try {
      const res = await changePassword(current, next, confirm);
      const fresh = res?.data?.user;
      if (fresh) updateUser(fresh);
      showToast("success", "Password updated");
      setCurrent(""); setNext(""); setConfirm("");
      onDone?.(fresh);
    } catch (err) {
      if (err?.data?.errors) setErrors(err.data.errors);
      showApiError(err, "Could not change password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="login-form">
      <div className="field">
        <label className="field-label">Current password</label>
        <input
          className="input"
          type={show ? "text" : "password"}
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
          autoFocus
        />
        {errors.current_password && <div className="field-error">{errors.current_password[0]}</div>}
      </div>
      <div className="field">
        <label className="field-label">New password</label>
        <input
          className="input"
          type={show ? "text" : "password"}
          autoComplete="new-password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
          placeholder="At least 8 characters"
        />
        {errors.new_password && <div className="field-error">{errors.new_password[0] || errors.new_password}</div>}
      </div>
      <div className="field">
        <label className="field-label">Confirm new password</label>
        <input
          className="input"
          type={show ? "text" : "password"}
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        {errors.new_password_confirmation && (
          <div className="field-error">{errors.new_password_confirmation[0] || errors.new_password_confirmation}</div>
        )}
      </div>
      <label className="row gap-sm" style={{ cursor: "pointer", fontSize: 13 }}>
        <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} />
        Show passwords
      </label>
      <button
        type="submit"
        className="btn btn-primary btn-lg login-submit"
        disabled={loading || !current || next.length < 8 || next !== confirm}
      >
        {loading ? (<><span className="spinner spinner-sm" /> Saving…</>) : (<>{submitLabel} <Icon name="arrow-right" size={14} /></>)}
      </button>
    </form>
  );
}
